import { TileMapLayer } from "../tiles.map.layer";
export class ImageLayer extends TileMapLayer {
    constructor(name, provider, options, enabled) {
        super(name, provider, options, enabled);
        this._draw = this._draw ?? this._renderTile.bind(this);
    }
    _renderTile(ctx, tile, w, h) {
        ctx.drawImage(tile.content, 0, 0, w + 1, h + 1);
    }
}
//# sourceMappingURL=tiles.map.layer.image.js.map